export default __webpack_public_path__ + "static/media/trash-icon-light.fe9598ca.svg";